import React from 'react';
import { LanguageProvider, useLanguage } from './i18n/LanguageProvider';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { StoryChapter } from './components/StoryChapter';
import { PatternList } from './components/PatternList';
import { MethodSteps } from './components/MethodSteps';
import { Timeline } from './components/Timeline';
import { Notice } from './components/Notice';
import { SiteFooter } from './components/SiteFooter';
function Investigation() {
  const {
    language,
    t
  } = useLanguage();
  return <div className="min-h-full w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="2mjzmh44o1nm1">
      <SiteHeader data-id="element-1" data-mp="31c9vc4zqn1rz" />
      <Hero data-id="element-2" data-mp="31cte1nx7pu72" />

      <main key={language} className="mx-auto max-w-4xl px-4 pb-4 pt-10" data-id="element-3" data-mp="31cjpm4rtfv3h">
        <StoryChapter id="el-caso" number="01" title={t.ch1.title} data-id="element-4" data-mp="2wip54z4dzc3c">
          <p className="drop-cap" data-id="element-5" data-mp="28te1n9vnj3li">{t.ch1.p1}</p>
          <p data-id="element-6" data-mp="28s2x37udtrtc">{t.ch1.p2}</p>
          <p data-id="element-7" data-mp="23vuo6c6s2uum">{t.ch1.p3}</p>
          <p className="border-l-2 border-accent pl-4 font-serif text-2xl italic leading-snug" data-id="element-8" data-mp="23u9q4cl98ts0">
            {t.ch1.pull}
          </p>
        </StoryChapter>

        <StoryChapter id="el-patron" number="02" title={t.ch2.title} data-id="element-9" data-mp="3mlj8uuvtnd32">
          <p data-id="element-10" data-mp="3mjpyp5m02aqb">{t.ch2.p1}</p>
          <PatternList items={t.ch2.items} data-id="element-11" data-mp="3rc9co3oln7vn" />
          <p data-id="element-12" data-mp="3rdkie91luppe">{t.ch2.p2}</p>
        </StoryChapter>

        <StoryChapter id="algo-no-cerraba" number="03" title={t.ch3.title} data-id="element-13" data-mp="5yimri0b7dt">
          <p data-id="element-14" data-mp="82kz509bybz">{t.ch3.p1}</p>
          <PatternList items={t.ch3.items} data-id="element-15" data-mp="2zld1d7i6tbah" />
          <p className="font-serif text-2xl italic leading-snug text-muted" data-id="element-16" data-mp="2zmenc70qri6z">{t.ch3.pull}</p>
        </StoryChapter>

        <StoryChapter id="la-organizacion" number="04" title={t.ch4.title} data-id="element-17" data-mp="33mymth8sexwa">
          <p data-id="element-18" data-mp="38l04bxqkep5n">{t.ch4.p1}</p>
          <PatternList items={t.ch4.items} data-id="element-19" data-mp="38kgocmkh6au9" />
          <p data-id="element-20" data-mp="3dle3eqa6uorj">{t.ch4.p2}</p>
        </StoryChapter>

        <StoryChapter id="el-metodo" number="05" title={t.ch5.title} data-id="element-21" data-mp="3dm60k5jfoujx">
          <p data-id="element-22" data-mp="nuhiqjqwkdut">{t.ch5.p1}</p>
          <MethodSteps data-id="element-23" data-mp="nvartrdc3fg4" />
          <p className="font-serif text-2xl italic leading-snug" data-id="element-24" data-mp="sunby4ctm8f0">{t.ch5.pull}</p>
        </StoryChapter>

        <StoryChapter id="linea-de-tiempo" number="06" title={t.ch6.title} data-id="element-25" data-mp="36hw15qrsq0p">
          <p data-id="element-26" data-mp="38kvegdtbvi3">{t.ch6.p1}</p>
          <Timeline data-id="element-27" data-mp="3ud1glcmeruc7" />
        </StoryChapter>

        <Notice data-id="element-28" data-mp="3ubzw6hji5vht" />
      </main>

      <SiteFooter data-id="element-29" data-mp="3uf5ixq4nslad" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-30" data-mp="d45t42bum9m1">
      <Investigation data-id="element-31" data-mp="d2l7513lnyzs" />
    </LanguageProvider>;
}